export default function HighscoreView(element, markFirst = true) {
  function update(entries, newHighscore) {
    element.innerHTML = "";
    element.appendChild(makeHighscoreTable(entries, newHighscore));
  }
  function makeHighscoreTable(entries, newHighscore) {
    const title = "Highscore";
    const table = document.createElement("table");
    table.classList.add("highscore-table");
    const caption = document.createElement("caption");
    caption.textContent = title;
    table.appendChild(caption);
    entries.forEach(([level, score], index) => {
      const row = document.createElement("tr");
      console.log("Rendering row", level, score, index, newHighscore);
      if (markFirst && !newHighscore && index === 0) {
        row.classList.add("clr-red");
      } else if (newHighscore && newHighscore == score) {
        row.classList.add("clr-yellow");
      }
      const levelCell = document.createElement("td");
      levelCell.textContent = level;
      const scoreCell = document.createElement("td");
      scoreCell.textContent = score;
      row.appendChild(levelCell);
      row.appendChild(scoreCell);
      table.appendChild(row);
    });
    if (newHighscore) {
      const footer = document.createElement("tfoot");
      const footerRow = document.createElement("tr");
      const footerCell = document.createElement("td");
      footerCell.setAttribute("colspan", "2");
      footerCell.classList.add("clr-red");
      footerCell.textContent = newHighscore ? "Du bist in der Highscore!" : "";
      footerRow.appendChild(footerCell);
      footer.appendChild(footerRow);
      table.appendChild(footer);
    }
    return table;
  }
  return {
    update
  };
}